<template lang="pug">
  r-form( 
    ref='form'
    submit-text='guardar'
    title='datos contrato tipo'
    v-bind='formProps' 
    v-model='hrContractStructure'
    @reset='submitReset'
    @submit='submitUpdate'
    )
</template>

<script>
  //
  import { RForm } from '@/components/reusable_components/next'
  import Translator from '@/services/translator'
  //
  import HrContractStructureModel from '@/models/HumanResource/HrContractStructure'
  import HrContractStructureFields from '@/views/HumanResource/HrContractStructure/HrContractStructureFields'
  //
  export default {
    components: {
      RForm,
    },
    computed: {
      formProps() {
        return {
          fields: HrContractStructureFields,
        }
      },
    },
    data() {
      return {
        hrContractStructure: null,
      }
    },
    methods: {
      setHrContractStructure(hrContractStructure) {
        this.hrContractStructure = hrContractStructure.reset()
      },
      showUpdateError(error) {
        this.showErrorSnackbar(Translator(HrContractStructureModel, error.response.data))
      },
      showUpdateSuccess() {
        this.showSuccessSnackbar('Contrato tipo actualizado exitosamente.')
      },
      submitUpdate() {
        return this
          .toWait(true)
          .then(this.toUpdate)
          .then(this.toWait)
      },
      submitReset() {
        return this
          .toWait(true)
          .then(this.toReset)
          .then(this.toWait)
      },
      toUpdate() {
        return this
          .hrContractStructure
          .toUpdate()
          .save()
          .then(this.showUpdateSuccess)
          .then(this.toRedirect)
          .catch(this.showUpdateError)
      },
      toRedirect() {
        this.$router.push({ name: 'contract-structure-list' })
      },
      toReset() {
        return HrContractStructureModel
          .find(this.$route.params.id)
          .then(this.setHrContractStructure)
      },
      toWait(value = false) {
        return this
          .$refs
          .form
          .setWait(value)
      },
    },
    mounted() {
      this
        .setTitle('Datos de contrato tipo #' + this.$route.params.id)
        .then(this.submitReset)
    },
    beforeRouteEnter(to, from, next) {
      next(ctx => {
        if (!ctx.$can('VIEW_ALL_HOLIDAY')) ctx.$router.push('/')
      })
    },
  }
</script>
